import { deleteFavorites, postFavorites } from '@app/packages/api/v2/actions/favorites'
import { deleteIgnoredUsersById, postIgnoredUsers } from '@app/packages/api/v2/actions/ignored_users'

import { addFavoriteSlice, removeFavoriteSlice } from '@app/store/slices/favorites'
import { clearIgnoredPendingSlice, invalidateIgnoredSlice, setIgnoredPendingSlice } from '@app/store/slices/ignored'
import { setUserFavoriteSlice } from '@app/store/slices/users'
import { createThunk } from '@app/store/thunk'

import { callV2Api } from './api'

/**
 * Each status is two calls, so the optimistic write is made once for the status asked for and
 * reverted once if either call fails — rather than per request, which left the two halves of a
 * change disagreeing when the second one broke.
 */
export const changeUserSubscriptionStatus = (id: string, status: null | 'favorite' | 'ignored') =>
  createThunk(async dispatch => {
    dispatch(setUserFavoriteSlice(id, status === 'favorite'))
    if (status === 'favorite') dispatch(removeFavoriteSlice(id))
    if (status === 'ignored') dispatch(setIgnoredPendingSlice(id, true))
    if (status === null) dispatch(setIgnoredPendingSlice(id, false))

    try {
      switch (status) {
        case 'favorite': {
          await dispatch(callV2Api(deleteIgnoredUsersById(id)))
          const resp = await dispatch(callV2Api(postFavorites(id)))
          dispatch(addFavoriteSlice(resp.data.id))
          break
        }
        case 'ignored': {
          await dispatch(callV2Api(deleteFavorites(id)))
          await dispatch(callV2Api(postIgnoredUsers(id)))
          dispatch(removeFavoriteSlice(id))
          break
        }
        case null: {
          await Promise.all([dispatch(callV2Api(deleteFavorites(id))), dispatch(callV2Api(deleteIgnoredUsersById(id)))])
          dispatch(removeFavoriteSlice(id))
          break
        }
      }
      dispatch(invalidateIgnoredSlice())
    } catch (e) {
      dispatch(setUserFavoriteSlice(id, status !== 'favorite'))
      dispatch(invalidateIgnoredSlice())
      throw e
    } finally {
      dispatch(clearIgnoredPendingSlice(id))
    }
  })
